import { Injectable } from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { Bloc, BlocEvent, BlocState, ErrorState, ProcessingState } from '../base-bloc';
import { TreeDropdownLoadEvent, TreeDropdownSearchEvent } from './tree-dropdown-event';
import { TreeDropdownReadyState, TreeDropdownSearchReadyState } from './tree-dropdown-state';
import { Drawing } from '../../model';

@Injectable()
export class TreeDropdownBloc extends Bloc<BlocEvent, BlocState> {
  constructor() {
    super();
  }

  onIncomingEvents(event: BlocEvent) {
    if (event instanceof TreeDropdownLoadEvent) {
      this.onState$.next(new ProcessingState(null));
      event
        .caller(event.page, event.limit, event.search)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            this.onState$.next(new TreeDropdownReadyState(res.items ? res.items : res, res.pagination));
          },
          error: (error) => {
            this.onState$.next(new ErrorState<Drawing>(new Drawing(), error));
          },
        });
    } else if (event instanceof TreeDropdownSearchEvent) {
      this.onState$.next(new ProcessingState(null));

      event
        .caller(event.page, event.limit, event.search)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            this.onState$.next(new TreeDropdownSearchReadyState(res.items, res.pagination));
          },
          error: (error) => {
            this.onState$.next(new ErrorState<Drawing>(new Drawing(), error));
          },
        });
    }
  }
}
